import template from "./import-costs-csv-modal.html";

const ImportCostsCsvModalComponent = {
  bindings: {
    close: "&",
    dismiss: "&",
  },
  template: template,
  controller: class ImportCostsCsvModalController {
    /* @ngInject */
    constructor($rootScope, $window, $filter, Notification, Cost) {
      this.$rootScope = $rootScope;
      this.$filter = $filter;
      this.$window = $window;
      this.NotificationService = Notification;
      this.Cost = Cost;
    }

    $onInit() {
      this.costsFile = null;
    }

    downloadCostsTemplate() {
      this.$window.open(`${process.env.CLIENT_URL}/resources/template-costs.csv`, "_blank");
    }

    async importCsv() {
      try {
        this.saving = true;
        const formData = new FormData();
        formData.append("csvFile", this.costsFile);
        await this.Cost.importCsv(formData);
        this.costsFile = null;
        this.saving = false;
        this.NotificationService.success({
          title: this.$filter("trans")("notificationService.title.success"),
          message: this.$filter("trans")("notificationService.message.costsImported"),
        });
        this.close({ $value: true });
      } catch (error) {
        this.costsFile = null;
        this.saving = false;
        if (
          error.status === 400 &&
          (error.data.includes("carpeta") ||
            error.data.includes("nombre") ||
            error.data.includes("unidad") ||
            error.data.includes("precio") ||
            error.data.includes("divisa") ||
            error.data.includes("comentarios"))
        ) {
          this.NotificationService.error({
            title: "¡Error en el CSV!",
            message: error.data,
          });
          this.close({ $value: false });
        } else if (error.status === 400 && error.data.includes("validation error")) {
          this.NotificationService.error({
            title: "¡Error en el fichero!",
            message: "Comprueba que el fichero sea de tipo CSV y que el formato se ajuste al de la plantilla.",
          });
          this.close({ $value: false });
        } else {
          this.saving = false;
          this.close({ $value: false });
          throw error;
        }
      }
    }
  },
};

export default ImportCostsCsvModalComponent;
